import { useQuery } from '@tanstack/react-query'
import { avatarQueryKeys } from '../constants'
import api from '../../config/axios-config'

const avatarBlobCache = new Map()
const avatarObjectUrlCache = new Map()

const getAvatarObjectUrl = (avatarUrl, blob) => {
  if (!avatarUrl || !blob) {
    return null
  }

  const cachedBlob = avatarBlobCache.get(avatarUrl)
  const cachedObjectUrl = avatarObjectUrlCache.get(avatarUrl)

  if (cachedBlob === blob && cachedObjectUrl) {
    return cachedObjectUrl
  }

  if (cachedObjectUrl) {
    URL.revokeObjectURL(cachedObjectUrl)
  }

  const nextObjectUrl = URL.createObjectURL(blob)

  avatarBlobCache.set(avatarUrl, blob)
  avatarObjectUrlCache.set(avatarUrl, nextObjectUrl)

  return nextObjectUrl
}

export const useGetAvatarQuery = (avatarUrl, options) => {
  const handleQuery = async () => {
    const config = {
      method: 'get',
      responseType: 'blob',
      skipHeaders: true
    }

    const { data } = await api(avatarUrl, config)

    if (!data || data.size === 0) {
      return null
    }

    return data
  }

  const query = useQuery({
    queryKey: [avatarQueryKeys.AVATAR_IMAGE, avatarUrl],
    queryFn: handleQuery,
    enabled: !!avatarUrl,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    ...options
  })

  return {
    ...query,
    data: getAvatarObjectUrl(avatarUrl, query.data)
  }
}
